import { Component, OnInit } from "@angular/core";
import { Input } from "@angular/core";

@Component({
    selector: "external-document-link",
    templateUrl: "./external-document-link.component.html",
    styleUrls: ["./external-document-link.component.scss"],
    standalone: false
})
export class ExternalDocumentLinkComponent implements OnInit {
	@Input() key: string;

	@Input() icon: string;

	@Input() displayTitle: string;

	@Input() linkTitle: string;

	@Input() link: string;

	constructor() {}

	ngOnInit() {}
}
